module.exports = __webpack_public_path__ + "img/adds.abbbd8d5.svg";